export interface SwitchProps {}

const Switch: React.FC<SwitchProps> = () => {
  return null
}

export default Switch
